import React from "react";
import { useLocation } from "react-router-dom";

const Correo = ({ param1, param2 }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const sello = queryParams.get("sello");
  const acepta = queryParams.get("acepta");

  return (
    <div>
      <meta charSet="UTF-8" />
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <meta name="x-apple-disable-message-reformatting" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta content="telephone=no" name="format-detection" />
      <title>Empty template</title>
      {/*[if (mso 16)]>
    <style type="text/css">
    a {text-decoration: none;}
    </style>
    <![endif]*/}
      {/*[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]*/}
      {/*[if gte mso 9]>
<noscript>
   <xml>
     <o:OfficeDocumentSettings>
     <o:AllowPNG></o:AllowPNG>
     <o:PixelsPerInch>96</o:PixelsPerInch>
     </o:OfficeDocumentSettings>
   </xml>
</noscript>
<![endif]*/}
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '\n#outlook a {\n\tpadding:0;\n}\n.es-button {\n\tmso-style-priority:100!important;\n\ttext-decoration:none!important;\n}\na[x-apple-data-detectors] {\n\tcolor:inherit!important;\n\ttext-decoration:none!important;\n\tfont-size:inherit!important;\n\tfont-family:inherit!important;\n\tfont-weight:inherit!important;\n\tline-height:inherit!important;\n}\n.es-desk-hidden {\n\tdisplay:none;\n\tfloat:left;\n\toverflow:hidden;\n\twidth:0;\n\tmax-height:0;\n\tline-height:0;\n\tmso-hide:all;\n}\n@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1, h2, h3, h1 a, h2 a, h3 a { line-height:120%!important } h1 { font-size:30px!important; text-align:left } h2 { font-size:24px!important; text-align:left } h3 { font-size:20px!important; text-align:left } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:30px!important; text-align:left } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:24px!important; text-align:left } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important; text-align:left } .es-menu td a { font-size:14px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:14px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:14px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:14px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:inline-block!important } a.es-button, button.es-button { font-size:18px!important; display:inline-block!important } .es-adaptive table, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } .es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; max-height:inherit!important } }\n@media screen and (max-width:384px) {.mail-message-content { width:414px!important } }\n',
        }}
      />
      <div
        dir="ltr"
        className="es-wrapper-color"
        lang="es"
        style={{ backgroundColor: "#F6F6F6" }}
      >
        {/*[if gte mso 9]>
			<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
				<v:fill type="tile" color="#f6f6f6"></v:fill>
			</v:background>
		<![endif]*/}
        <table
          className="es-wrapper"
          width="100%"
          cellSpacing={0}
          cellPadding={0}
          role="none"
          style={{
            msoTableLspace: "0pt",
            msoTableRspace: "0pt",
            borderCollapse: "collapse",
            borderSpacing: 0,
            padding: 0,
            margin: 0,
            width: "100%",
            height: "100%",
            backgroundRepeat: "repeat",
            backgroundPosition: "center top",
            backgroundColor: "#F6F6F6",
          }}
        >
          <tbody>
            <tr>
              <td valign="top" style={{ padding: 0, margin: 0 }}>
                <table
                  className="es-header"
                  cellSpacing={0}
                  cellPadding={0}
                  align="center"
                  role="none"
                  style={{
                    msoTableLspace: "0pt",
                    msoTableRspace: "0pt",
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                    tableLayout: "fixed !important",
                    width: "100%",
                    backgroundColor: "transparent",
                    backgroundRepeat: "repeat",
                    backgroundPosition: "center top",
                  }}
                >
                  <tbody>
                    <tr>
                      <td align="center" style={{ padding: 0, margin: 0 }}>
                        <table
                          className="es-header-body"
                          cellSpacing={0}
                          cellPadding={0}
                          bgcolor="#ffffff"
                          align="center"
                          role="none"
                          style={{
                            msoTableLspace: "0pt",
                            msoTableRspace: "0pt",
                            borderCollapse: "collapse",
                            borderSpacing: 0,
                            backgroundColor: "#FFFFFF",
                            width: 600,
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                align="left"
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  paddingTop: 20,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                }}
                              >
                                <table
                                  width="100%"
                                  cellSpacing={0}
                                  cellPadding={0}
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        align="center"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 560,
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellSpacing={0}
                                          cellPadding={0}
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                  fontSize: 0,
                                                }}
                                              >
                                                <img
                                                  className="adapt-img"
                                                  src="https://ikyotf.stripocdn.email/content/guids/CABINET_4b49fcd345fe5f25099219ac445dcae7e761226dd54e83422043b70b5d4d340e/images/headdefin.PNG"
                                                  alt
                                                  style={{
                                                    display: "block",
                                                    border: 0,
                                                    outline: "none",
                                                    textDecoration: "none",
                                                    msInterpolationMode:
                                                      "bicubic",
                                                  }}
                                                  width={560}
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  className="es-content"
                  cellSpacing={0}
                  cellPadding={0}
                  align="center"
                  role="none"
                  style={{
                    msoTableLspace: "0pt",
                    msoTableRspace: "0pt",
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                    tableLayout: "fixed !important",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td align="center" style={{ padding: 0, margin: 0 }}>
                        <table
                          className="es-content-body"
                          cellSpacing={0}
                          cellPadding={0}
                          bgcolor="#ffffff"
                          align="center"
                          role="none"
                          style={{
                            msoTableLspace: "0pt",
                            msoTableRspace: "0pt",
                            borderCollapse: "collapse",
                            borderSpacing: 0,
                            backgroundColor: "#FFFFFF",
                            width: 600,
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                align="left"
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  paddingTop: 20,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                }}
                              >
                                {/*[if mso]><table style="width:560px" cellpadding="0" cellspacing="0"><tr><td style="width:420px" valign="top"><![endif]*/}
                                <table
                                  cellSpacing={0}
                                  cellPadding={0}
                                  align="left"
                                  className="es-left"
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                    float: "left",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="es-m-p20b"
                                        valign="top"
                                        align="center"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 420,
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellSpacing={0}
                                          cellPadding={0}
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="left"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",

                                                    color: "#0085ca",
                                                    fontSize: 16,
                                                  }}
                                                >
                                                  En nombre de ICONTEC, queremos
                                                  hacerle llegar a su
                                                  organización y a todos sus
                                                  colaboradores un saludo muy
                                                  especial, así como agradecerle
                                                  por la decisión de adquirir
                                                  nuestros servicios
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]></td><td style="width:20px"></td><td style="width:120px" valign="top"><![endif]*/}
                                <table
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="es-right"
                                  align="right"
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                    float: "right",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="left"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 120,
                                        }}
                                      >
                                        <table
                                          cellPadding={0}
                                          cellSpacing={0}
                                          width="100%"
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                  fontSize: 0,
                                                }}
                                              >
                                                <img
                                                  className="adapt-img"
                                                  src={sello}
                                                  alt="sello"
                                                  width="100%"
                                                  style={{
                                                    display: "block",
                                                    border: 0,
                                                    outline: "none",
                                                    textDecoration: "none",
                                                    msInterpolationMode:
                                                      "bicubic",
                                                    fontSize: 12,
                                                  }}
                                                  title="sello"
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]></td></tr></table><![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  className="es-content"
                  cellSpacing={0}
                  cellPadding={0}
                  align="center"
                  role="none"
                  style={{
                    msoTableLspace: "0pt",
                    msoTableRspace: "0pt",
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                    tableLayout: "fixed !important",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td align="center" style={{ padding: 0, margin: 0 }}>
                        <table
                          className="es-content-body"
                          cellSpacing={0}
                          cellPadding={0}
                          bgcolor="#ffffff"
                          align="center"
                          role="none"
                          style={{
                            msoTableLspace: "0pt",
                            msoTableRspace: "0pt",
                            borderCollapse: "collapse",
                            borderSpacing: 0,
                            backgroundColor: "#FFFFFF",
                            width: 600,
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                align="left"
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  paddingTop: 20,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                }}
                              >
                                <table
                                  width="100%"
                                  cellSpacing={0}
                                  cellPadding={0}
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        align="center"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 560,
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellSpacing={0}
                                          cellPadding={0}
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="left"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",

                                                    color: "#002e5d",
                                                    fontSize: 15,
                                                  }}
                                                >
                                                  Por medio del presente correo
                                                  electrónico
                                                </p>
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    WebkitTextSizeAdjust:
                                                      "none",
                                                    msTextSizeAdjust: "none",
                                                    msoLineHeightRule:
                                                      "exactly",
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",
                                                    lineHeight: "22.5px",
                                                    color: "#002e5d",
                                                    fontSize: 15,
                                                  }}
                                                >
                                                  le hacemos entrega de su
                                                  certificado
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  className="es-content"
                  cellSpacing={0}
                  cellPadding={0}
                  align="center"
                  role="none"
                  style={{
                    msoTableLspace: "0pt",
                    msoTableRspace: "0pt",
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                    tableLayout: "fixed !important",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td align="center" style={{ padding: 0, margin: 0 }}>
                        <table
                          className="es-content-body"
                          cellSpacing={0}
                          cellPadding={0}
                          bgcolor="#ffffff"
                          align="center"
                          role="none"
                          style={{
                            msoTableLspace: "0pt",
                            msoTableRspace: "0pt",
                            borderCollapse: "collapse",
                            borderSpacing: 0,
                            backgroundColor: "#FFFFFF",
                            width: 600,
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                align="left"
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  paddingTop: 20,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                }}
                              >
                                <table
                                  width="100%"
                                  cellSpacing={0}
                                  cellPadding={0}
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        align="center"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 560,
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellSpacing={0}
                                          cellPadding={0}
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="left"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",

                                                    color: "#878787",
                                                    fontSize: 15,
                                                  }}
                                                >
                                                  Lo felicitamos por este gran
                                                  logro, estamos complacidos de
                                                  poder apoyar a su organización
                                                  con su crecimiento sostenible
                                                  y esperamos seguir trabajando
                                                  de la mano por incrementar los
                                                  índices de competitividad y
                                                  productividad de nuestro país
                                                  y dejar una huella de
                                                  confianza que se contribuya a
                                                  la construcción del futuro con
                                                  el que todos soñamos
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table
                  className="es-footer"
                  cellSpacing={0}
                  cellPadding={0}
                  align="center"
                  role="none"
                  style={{
                    msoTableLspace: "0pt",
                    msoTableRspace: "0pt",
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                    tableLayout: "fixed !important",
                    width: "100%",
                    backgroundColor: "transparent",
                    backgroundRepeat: "repeat",
                    backgroundPosition: "center top",
                  }}
                >
                  <tbody>
                    <tr>
                      <td align="center" style={{ padding: 0, margin: 0 }}>
                        <table
                          className="es-footer-body"
                          cellSpacing={0}
                          cellPadding={0}
                          bgcolor="#ffffff"
                          align="center"
                          role="none"
                          style={{
                            msoTableLspace: "0pt",
                            msoTableRspace: "0pt",
                            borderCollapse: "collapse",
                            borderSpacing: 0,
                            backgroundColor: "#FFFFFF",
                            width: 600,
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                align="left"
                                style={{
                                  margin: 0,
                                  paddingTop: 20,
                                  paddingBottom: 20,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                }}
                              >
                                {/*[if mso]><table style="width:560px" cellpadding="0" cellspacing="0"><tr><td style="width:260px" valign="top"><![endif]*/}
                                <table
                                  cellSpacing={0}
                                  cellPadding={0}
                                  align="left"
                                  className="es-left"
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                    float: "left",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="es-m-p20b"
                                        align="left"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 260,
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellSpacing={0}
                                          cellPadding={0}
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="right"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",
                                                    color: "#002e5d",
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  Agradecemos aceptar y
                                                  descargar su certificado
                                                  haciendo clic en el siguiente
                                                  botón
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]></td><td style="width:20px"></td><td style="width:280px" valign="top"><![endif]*/}
                                <table
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="es-right"
                                  align="right"
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                    float: "right",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="left"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 280,
                                        }}
                                      >
                                        <table
                                          cellPadding={0}
                                          cellSpacing={0}
                                          width="100%"
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                bgcolor="#ffffff"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                {/*[if mso]><a href={acepta} target="_blank" hidden>
	<v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" esdevVmlButton href={acepta} 
          style="height:33px; v-text-anchor:middle; width:278px" arcsize="50%" strokecolor="#0085ca" strokeweight="1px" fillcolor="#ffffff">
		<w:anchorlock></w:anchorlock>
		<center style='color:#002e5d; font-family:verdana, geneva, sans-serif; font-size:11px; font-weight:700; line-height:11px;  mso-text-raise:1px'>ACEPTE Y DESCARGUE SU CERTIFICADO</center>
	</v:roundrect></a>
<![endif]*/}
                                                {/*[if !mso]><!-- */}
                                                <span
                                                  className="msohide es-button-border"
                                                  style={{
                                                    borderStyle: "solid",
                                                    borderColor: "#0085ca",
                                                    background: "#ffffff",
                                                    borderWidth: 2,
                                                    display: "inline-block",
                                                    borderRadius: 42,
                                                    width: "auto",
                                                    msoHide: "all",
                                                  }}
                                                >
                                                  <a
                                                    href={acepta}
                                                    className="es-button es-button-1725307099974"
                                                    target="_blank"
                                                    style={{
                                                      msoStylePriority:
                                                        "100 !important",
                                                      textDecoration: "none",
                                                      WebkitTextSizeAdjust:
                                                        "none",
                                                      msTextSizeAdjust: "none",
                                                      msoLineHeightRule:
                                                        "exactly",
                                                      color: "#002e5d",
                                                      fontSize: 14,
                                                      display: "inline-block",
                                                      background: "#ffffff",
                                                      borderRadius: 42,
                                                      fontFamily:
                                                        "verdana, geneva, sans-serif",
                                                      fontWeight: "bold",
                                                      fontStyle: "normal",
                                                      lineHeight: "16.8px",
                                                      width: "auto",
                                                      textAlign: "center",
                                                      padding: 0,
                                                      msoPaddingAlt: 0,
                                                      msoBorderAlt:
                                                        "10px solid #ffffff",
                                                    }}
                                                  >
                                                    ACEPTE Y DESCARGUE SU
                                                    CERTIFICADO
                                                  </a>
                                                </span>
                                                {/*<![endif]*/}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]></td></tr></table><![endif]*/}
                              </td>
                            </tr>
                            <tr>
                              <td
                                align="left"
                                style={{
                                  margin: 0,
                                  paddingTop: 20,
                                  paddingBottom: 20,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                }}
                              >
                                <table
                                  cellSpacing={0}
                                  cellPadding={0}
                                  width="100%"
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="left"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 560,
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellSpacing={0}
                                          cellPadding={0}
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="left"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",
                                                    color: "#002e5d",
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  <strong>
                                                    Paso 1: Acepte y descargue
                                                    su certificado
                                                  </strong>
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                align="left"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    WebkitTextSizeAdjust:
                                                      "none",
                                                    msTextSizeAdjust: "none",
                                                    msoLineHeightRule:
                                                      "exactly",
                                                    fontFamily:
                                                      'arial, "helvetica neue", helvetica, sans-serif',
                                                    lineHeight: "22.5px",
                                                    color: "#878787",
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  <b>
                                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp;&nbsp;
                                                    <span
                                                      style={{ fontSize: 14 }}
                                                    />
                                                  </b>
                                                  <span
                                                    style={{ fontSize: 14 }}
                                                  >
                                                    Para lo cual debe hacer clic
                                                    en el botón "Acepte y
                                                    descargue su
                                                    certificado"&nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp;&nbsp;o en el
                                                    siguiente{" "}
                                                    <a
                                                      target="_blank"
                                                      style={{
                                                        WebkitTextSizeAdjust:
                                                          "none",
                                                        msTextSizeAdjust:
                                                          "none",
                                                        msoLineHeightRule:
                                                          "exactly",
                                                        textDecoration:
                                                          "underline",
                                                        color: "#0b5394",
                                                        fontSize: 13,
                                                      }}
                                                      href={acepta}
                                                    >
                                                      enlace
                                                    </a>
                                                  </span>
                                                  <b style={{ fontSize: 13 }} />
                                                  <span
                                                    style={{ fontSize: 15 }}
                                                  />
                                                  <br />
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                align="left"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",
                                                    color: "#002e5d",
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  <b>&nbsp;</b>
                                                  <strong>
                                                    Paso 2: Comparta su
                                                    certificado en redes
                                                    sociales
                                                  </strong>
                                                  <b style={{ fontSize: 13 }} />
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                align="left"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    margin: 0,
                                                    WebkitTextSizeAdjust:
                                                      "none",
                                                    msTextSizeAdjust: "none",
                                                    msoLineHeightRule:
                                                      "exactly",
                                                    fontFamily:
                                                      'arial, "helvetica neue", helvetica, sans-serif',
                                                    lineHeight: "22.5px",
                                                    color: "#878787",
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; Una vez
                                                  haya aceptado su certificado,
                                                  en la parte inferior del mismo
                                                  encontrará &nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp;los iconos de los
                                                  redes sociales{" "}
                                                  <strong>Facebook</strong> y
                                                  <strong> LinkedIn.</strong> Al
                                                  hacer clic en&nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp;cualquiera de
                                                  ellos, podra compartir su
                                                  certificado en la red
                                                  social&nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp; &nbsp; &nbsp; &nbsp;
                                                  &nbsp;correspondiente.
                                                </p>
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",
                                                    color: "#878787",
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  <br />
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td
                                align="left"
                                style={{
                                  margin: 0,
                                  paddingTop: 20,
                                  paddingBottom: 20,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                }}
                              >
                                {/*[if mso]><table style="width:560px" cellpadding="0" 
                  cellspacing="0"><tr><td style="width:357px" valign="top"><![endif]*/}
                                <table
                                  className="es-left"
                                  cellSpacing={0}
                                  cellPadding={0}
                                  align="left"
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                    float: "left",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="es-m-p20b"
                                        align="left"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 357,
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellSpacing={0}
                                          cellPadding={0}
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                  fontSize: 0,
                                                }}
                                              >
                                                <img
                                                  className="adapt-img"
                                                  src="https://ikyotf.stripocdn.email/content/guids/CABINET_4b49fcd345fe5f25099219ac445dcae7e761226dd54e83422043b70b5d4d340e/images/letrablock.PNG"
                                                  alt
                                                  style={{
                                                    display: "block",
                                                    border: 0,
                                                    outline: "none",
                                                    textDecoration: "none",
                                                    msInterpolationMode:
                                                      "bicubic",
                                                  }}
                                                  width={357}
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <td
                                                align="left"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",
                                                    color: "#999999",
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  Si tiene algún problema con su
                                                  certificado contáctenos{" "}
                                                  <strong>
                                                    <a
                                                      target="_blank"
                                                      href="https://www.icontec.org/"
                                                      style={{
                                                        WebkitTextSizeAdjust:
                                                          "none",
                                                        msTextSizeAdjust:
                                                          "none",
                                                        msoLineHeightRule:
                                                          "exactly",
                                                        textDecoration:
                                                          "underline",
                                                        color: "#002e5d",
                                                        fontSize: 14,
                                                      }}
                                                    >
                                                      {" "}
                                                      haciendo clic aquí
                                                    </a>
                                                  </strong>
                                                  , adjuntando una captura de
                                                  pantalla.
                                                </p>
                                                <p
                                                  style={{
                                                    fontFamily:
                                                      "verdana, geneva, sans-serif",
                                                    color: "#999999",
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  Resolveremos su situación a la
                                                  brevedad posible
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]></td><td style="width:20px"></td><td style="width:183px" valign="top"><![endif]*/}
                                <table
                                  className="es-right"
                                  cellSpacing={0}
                                  cellPadding={0}
                                  align="right"
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                    float: "right",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="left"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 183,
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellSpacing={0}
                                          cellPadding={0}
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                  fontSize: 0,
                                                }}
                                              >
                                                <img
                                                  className="adapt-img"
                                                  src="https://ikyotf.stripocdn.email/content/guids/CABINET_4b49fcd345fe5f25099219ac445dcae7e761226dd54e83422043b70b5d4d340e/images/huellablock.PNG"
                                                  alt
                                                  style={{
                                                    display: "block",
                                                    border: 0,
                                                    outline: "none",
                                                    textDecoration: "none",
                                                    msInterpolationMode:
                                                      "bicubic",
                                                  }}
                                                  width={183}
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]></td></tr></table><![endif]*/}
                              </td>
                            </tr>
                            <tr>
                              <td
                                align="left"
                                style={{
                                  padding: 0,
                                  margin: 0,
                                  paddingTop: 20,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                }}
                              >
                                <table
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  role="none"
                                  style={{
                                    msoTableLspace: "0pt",
                                    msoTableRspace: "0pt",
                                    borderCollapse: "collapse",
                                    borderSpacing: 0,
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        valign="top"
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                          width: 560,
                                        }}
                                      >
                                        <table
                                          cellPadding={0}
                                          cellSpacing={0}
                                          width="100%"
                                          role="presentation"
                                          style={{
                                            msoTableLspace: "0pt",
                                            msoTableRspace: "0pt",
                                            borderCollapse: "collapse",
                                            borderSpacing: 0,
                                          }}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{
                                                  padding: 0,
                                                  margin: 0,
                                                  fontSize: 0,
                                                }}
                                              >
                                                <img
                                                  className="adapt-img"
                                                  src="https://ikyotf.stripocdn.email/content/guids/CABINET_4b49fcd345fe5f25099219ac445dcae7e761226dd54e83422043b70b5d4d340e/images/footfinal_mOW.PNG"
                                                  alt
                                                  style={{
                                                    display: "block",
                                                    border: 0,
                                                    outline: "none",
                                                    textDecoration: "none",
                                                    msInterpolationMode:
                                                      "bicubic",
                                                  }}
                                                  width={560}
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Correo;
